export default __webpack_public_path__ + "static/media/st_help2.b82491ae.jpg";